const VISORIA_BACKEND_URL =
  process.env.REACT_APP_VISORIA_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "";

function formatMoney(amount, currency) {
  if (amount == null || amount === "") {
    return "";
  }
  const value = Number(amount);
  if (Number.isNaN(value)) {
    return String(amount);
  }
  try {
    return new Intl.NumberFormat("ru-RU", {
      style: "currency",
      currency: currency || "USD",
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value} ${currency || ""}`.trim();
  }
}

function mapDeal(game) {
  const pricing = game?.pricing || {};
  return {
    id: game.id,
    name: game.name || "Без названия",
    cover: game.cover || "",
    link: game.psprices_url || game.url || game.store_url || "#",
    discountPercent: pricing.discount_percent ?? null,
    price: formatMoney(pricing.current_price, pricing.currency),
    originalPrice: formatMoney(pricing.original_price, pricing.currency),
    discountEndDate: pricing.discount_ends_at || null,
    platforms: game.platforms || [],
  };
}

function buildCollectionUrl(region, platformQuery) {
  const safeRegion = encodeURIComponent(String(region || "us").toLowerCase());
  const safePlatform = encodeURIComponent(String(platformQuery || ""));
  return `https://psprices.com/region-${safeRegion}/collection/most-wanted-deals?platform=${safePlatform}`;
}

const pspricesDealsService = {
  getDeals: async (region, platforms) => {
    const params = new URLSearchParams({
      region: String(region || "").toLowerCase(),
      platforms: String(platforms || ""),
      collection: "most-wanted-deals",
    });
    const url = `${VISORIA_BACKEND_URL}/api/visoria/psprices/demo?${params.toString()}`;
    const response = await fetch(url, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) {
      throw new Error(`psprices proxy HTTP ${response.status}`);
    }
    const payload = await response.json();
    const results = Array.isArray(payload?.data)
      ? payload.data.slice(0, 24).map(mapDeal)
      : [];
    return {
      results,
      count: results.length,
      meta: payload?.meta || {},
    };
  },
  buildCollectionUrl,
};

export default pspricesDealsService;
